import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import { Spinner } from "reactstrap"; // or whatever Spinner you use

const LiveStreamModal = ({ streamUrl }) => {
    const videoRef = useRef(null);
    const hlsRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!streamUrl || !videoRef.current) return;

        video.crossOrigin = "use-credentials";
        video.playsInline = true;
        if (Hls.isSupported()) {
            const hls = new Hls({
                // Live tuning (adjust if needed)
                lowLatencyMode: false,
                liveSyncDurationCount: 3,
                liveMaxLatencyDurationCount: 10,
                // Retry/backoff
                manifestLoadingMaxRetry: 6,
                manifestLoadingRetryDelay: 1000,
                levelLoadingMaxRetry: 6,
                levelLoadingRetryDelay: 1000,
                fragLoadingMaxRetry: 6,
                fragLoadingRetryDelay: 1000,
                // Ensure credentials/cookies flow to the origin via CF/ALB
                // Use fetchSetup for newer hls.js; keep xhrSetup for older versions.
                fetchSetup: (context, init) =>
                    new Request(context.url, { ...init, credentials: "omit" }),
                xhrSetup: (xhr) => { try { xhr.withCredentials = false; } catch (_) { } },
            });

            hlsRef.current = hls;
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, () => hls.loadSource(streamUrl));
            hls.on(Hls.Events.MANIFEST_PARSED, () => { video.play().catch(() => { }); });

            // Basic auto-recovery
            hls.on(Hls.Events.ERROR, (evt, data) => {
                console.warn("HLS error:", data);
                if (data.fatal) {
                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();                 // retry
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            hls.recoverMediaError();
                            break;
                        default:
                            hls.destroy();
                            hlsRef.current = null;
                    }
                }
            });

            
        } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
            videoRef.current.src = streamUrl;
            videoRef.current.addEventListener("loadedmetadata", () => {
                videoRef.current.play();
            });
        }

        return () => {
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
        };
    }, [streamUrl]);

    return streamUrl ? (
        <video
            ref={videoRef}
            controls
            autoPlay
            style={{ width: "100%", height: "auto", backgroundColor: "black" }}
        />
    ) : (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <Spinner color="primary" />
            <div>Loading live stream...</div>
        </div>
    );
};

export default LiveStreamModal;